

// import React, { useState, useEffect } from "react";
// import { UploadCloud, X } from "lucide-react";
// import { useGallery } from "../context/GalleryContext";
// import toast from "react-hot-toast";

// const GalleryModal = ({ close, editData }) => {
//   const { addImage, updateImage } = useGallery();

//   const [form, setForm] = useState({
//     id: null,
//     title: "",
//     tag: "",
//     image: "",
//   });

//   useEffect(() => {
//     if (editData) {
//       setForm(editData);
//     }
//   }, [editData]);

//   const handleImageUpload = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     const reader = new FileReader();
//     reader.onloadend = () => {
//       setForm((prev) => ({
//         ...prev,
//         image: reader.result,
//       }));
//     };
//     reader.readAsDataURL(file);
//   };
// const handleSave = () => {
//   if (!form.title || !form.image) return;

//   if (editData) {
//     updateImage(form);
//     toast.success("Gallery updated ✅");
//   } else {
//     addImage({
//       ...form,
//       id: Date.now(),
//     });
//     toast.success("Gallery added ✅");
//   }

//   close();
// };

// return (
//   <div className="fixed inset-0 bg-black/40 flex justify-center items-start z-50 p-3 md:p-4 overflow-y-auto">
    
//     <div className="bg-white w-full max-w-2xl rounded-xl shadow-xl relative max-h-[90vh] overflow-y-auto">

//       {/* Header */}
//       <div className="flex justify-between items-center border-b px-4 md:px-6 py-4 sticky top-0 bg-white z-10">
//         <h2 className="font-serif text-base md:text-lg">
//           {editData ? "Edit Gallery Image" : "Add Gallery Image"}
//         </h2>

//         <button onClick={close} className="text-gray-500 hover:text-red-500">
//           <X size={20} />
//         </button>
//       </div>

//       {/* Body */}
//       <div className="p-4 md:p-6 space-y-6">

//         {/* Upload + Preview */}
//         <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6">

//           {/* Upload */}
//           <label className="border-2 border-dashed h-[160px] md:h-[180px] rounded-lg flex flex-col items-center justify-center text-gray-500 cursor-pointer hover:border-[#6f8f2f] transition">
//             <UploadCloud className="text-[#6f8f2f] mb-2" size={28} />
//             <span className="text-sm">Upload Image</span>
//             <p className="text-xs">Recommended: 1920x1080px</p>

//             <input type="file" accept="image/*" onChange={handleImageUpload} className="hidden" />
//           </label>

//           {/* Preview */}
//           <div className="h-[160px] md:h-[180px] rounded-lg overflow-hidden bg-gray-100 flex items-center justify-center">
//             {form.image ? (
//               <img src={form.image} className="w-full h-full object-cover" />
//             ) : (
//               <span className="text-sm text-gray-400">Image preview</span>
//             )}
//           </div>
//         </div>

//         {/* Inputs */}
//         <div className="space-y-4">
//           <div>
//             <label className="text-sm font-medium text-gray-600">
//               Image Title
//             </label>
//             <input
//               className="w-full border mt-1 p-3 rounded-md focus:ring-2 focus:ring-[#6f8f2f]"
//               value={form.title}
//               onChange={(e) =>
//                 setForm({ ...form, title: e.target.value })
//               }
//             />
//           </div>

//           <div>
//             <label className="text-sm font-medium text-gray-600">
//               Image Tag
//             </label>
//             <input
//               className="w-full border mt-1 p-3 rounded-md focus:ring-2 focus:ring-[#6f8f2f]"
//               value={form.tag}
//               onChange={(e) =>
//                 setForm({ ...form, tag: e.target.value })
//               }
//             />
//           </div>
//         </div>

//         {/* Footer */}
//         <div className="flex justify-end">
//           <button
//             onClick={handleSave}
//             className="bg-[#45A301] text-white px-5 py-2 rounded-md text-sm"
//           >
//             {editData ? "Update Image" : "Add to Gallery"}
//           </button>
//         </div>
//       </div>
//     </div>
//   </div>
// );
// };

// export default GalleryModal;



import { useState, useEffect } from "react";
import { FiX, FiUploadCloud } from "react-icons/fi";
import { toast } from "react-toastify";
import SummaryApi from "../common/SummaryApi";
import api from "../common/apiClient";

const GalleryModal = ({ close, editData, refresh }) => {
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    title: "",
    tag: "",
    section: "gallery",
    type: "IMAGE",
    image: null
  });
  const [preview, setPreview] = useState(null);

  useEffect(() => {
    if (editData) {
      setForm({ ...editData });
      setPreview(editData.image?.url);
    }
  }, [editData]);

  const handleSave = async () => {
    if (!form.title) return toast.warning("Title is required");
    
    setLoading(true);
    const formData = new FormData();
    formData.append("title", form.title);
    formData.append("tag", form.tag || "");
    formData.append("type", "IMAGE");
    formData.append("section", "gallery");
    if (form.image instanceof File) formData.append("image", form.image);

    try {
      const apiConfig = editData 
        ? { url: SummaryApi.updateOneGallery.url(editData._id), method: SummaryApi.updateOneGallery.method }
        : { url: SummaryApi.createGallery.url, method: SummaryApi.createGallery.method };

      await api({ ...apiConfig, data: formData, headers: { "Content-Type": "multipart/form-data" } });
      toast.success(editData ? "Image Updated" : "Image Added");
      refresh();
      close();
    } catch (err) {
      toast.error("Upload failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-[10000] flex items-center justify-center p-4">
      <div className="bg-white w-full max-w-lg rounded-xl shadow-2xl overflow-hidden">
        <div className="flex justify-between items-center px-6 py-4 border-b bg-gray-50">
          <h3 className="font-bold">{editData ? "Edit Gallery" : "Add Gallery"}</h3>
          <button onClick={close}><FiX size={20} /></button>
        </div>
        <div className="p-6 space-y-6">
          <label className="border-2 border-dashed h-48 rounded-xl flex flex-col items-center justify-center cursor-pointer hover:bg-gray-50 overflow-hidden relative">
            {preview ? (
              <img src={preview} className="h-full w-full object-cover" alt="preview" />
            ) : (
              <div className="text-center">
                <FiUploadCloud size={40} className="mx-auto text-[#45A301]" />
                <p className="mt-2 text-sm text-gray-500 font-medium">Upload Image</p>
              </div>
            )}
            <input type="file" className="hidden" accept="image/*" onChange={e => {
              const file = e.target.files[0];
              setForm({...form, image: file});
              setPreview(URL.createObjectURL(file));
            }} />
          </label>
          <div className="space-y-4">
            <div><label className="text-xs font-bold text-gray-500 uppercase">Title</label>
            <input className="w-full border p-2.5 rounded-lg mt-1" value={form.title} onChange={e => setForm({...form, title: e.target.value})} /></div>
            <div><label className="text-xs font-bold text-gray-500 uppercase">Tag (e.g. Cardamom, Plantation)</label>
            <input className="w-full border p-2.5 rounded-lg mt-1" value={form.tag} onChange={e => setForm({...form, tag: e.target.value})} /></div>
          </div>
        </div>
        <div className="p-6 border-t bg-gray-50 flex justify-end gap-3">
          <button onClick={close} className="px-4 py-2 border rounded text-sm font-medium">Cancel</button>
          <button onClick={handleSave} disabled={loading} className="px-6 py-2 bg-[#45A301] text-white rounded text-sm font-medium disabled:opacity-50">
            {loading ? "Uploading..." : "Save Image"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default GalleryModal;